export default __webpack_public_path__ + "static/media/ID_NEWYORK_MELISSA.2ca3bed4.jpg";